// WHERE A DESK WALLET IS ADDED (his rule, 4 Nov 2026: "so, all desk ERC wallets should be listed under same wallet
// apparantly , same for trc/btc n all"). A desk wallet goes under its group · network — the desk account named
// "Hot · ERC20" (db/0104) — never under a folder of desk accounts such as "Crypto office assets" (db/0011): a folder has
// no Books account, and the chain reader never reads a wallet there (register #58, added there on 3 Nov, unseen until
// db/0112 moved it). The register's Add wallet asks Desk or Party: Desk offers only desk accounts with a Books account,
// a group · network first with its network fixed; Party offers customers and merchants only. The name is built
// (TERMINOLOGY §2), so a desk wallet takes no typed label. The class is the Books server's, from the desk account.
import { WALLET_CHAINS } from './walletStates';

type Chain = typeof WALLET_CHAINS[number];
type Row = { slug: string; display_name?: string | null; party_type?: string | null; treasury_slug?: string | null };

/** The groups, in the order the picker lists them (TERMINOLOGY §2). */
const GROUPS = ['Hot', 'Merchant Hot', 'Treasury', 'Investment', 'Fee', 'Deposit', 'Flagged'] as const;
/** A network as a name spells it → the register's chain code. A network the register has no code for is not offered. */
const CHAIN_OF: Record<string, Chain> = { TRC20: 'TRC20', ERC20: 'ERC20', BEP20: 'BEP20', Base: 'BASE', SOL: 'SOL', BTC: 'BTC' };

/** A desk account that can hold a wallet: the desk's own, with a Books account (a folder of them has none), and not
 *  cash or a bank account, which hold no address. */
export const isDeskAccount = (p: Row): boolean =>
  p.party_type === 'own_account' && !!p.treasury_slug && !/^(cash|bank)\./.test(p.treasury_slug);

/** A group · network account's chain ("Hot · ERC20" → ERC20); null for any other desk account. */
export function pairChain(p: Row): Chain | null {
  const m = /^(.+) · (\S+)$/.exec(p.display_name ?? '');
  if (!m || !(GROUPS as readonly string[]).includes(m[1]!)) return null;
  return CHAIN_OF[m[2]!] ?? null;
}

export type DeskAccount = { slug: string; name: string; chain: Chain | null };

/** The Desk side's choices: each group · network first, in group order, then the other desk accounts by name. */
export function deskAccounts(rows: readonly Row[]): DeskAccount[] {
  const rank = (a: DeskAccount) => (a.chain ? GROUPS.findIndex((g) => a.name.startsWith(`${g} · `)) : GROUPS.length);
  return rows.filter(isDeskAccount)
    .map((p) => ({ slug: p.slug, name: p.display_name || p.slug, chain: pairChain(p) }))
    .sort((a, b) => rank(a) - rank(b) || a.name.localeCompare(b.name));
}
